@if (message(); as message) {
  <div class="pinned-message-card" [attr.data-testid]="testIds.fieldPinnedmessage">
    <div
      class="pin-icon"
      tabindex="0"
      role="button"
      (click)="this.handleUnpinClick($event, message.messageId)"
      (keydown)="onKeyDown($event, message.messageId)"
      matTooltip="Lösen"
      matTooltipPosition="right"
      matTooltipPositionAtOrigin="true">
      <mat-icon svgIcon="pin-icon-mini" class="small-pin"></mat-icon>
    </div>
    <div class="pin-content">
      <div class="pin-header">
        <div class="user-icon">
          <app-user-icon
            [userId]="message.senderId"
            [scaleForPinned]="true"
            [presenceStatus]="undefined"></app-user-icon>
        </div>
        <div class="sender">
          {{ message.sender }}
        </div>
      </div>
      <div [attr.data-testid]="testIds.fieldMessageContent" class="msg-content pin-message">
        @if (message.msgType === MsgType.Image || message.msgType === MsgType.File) {
          <span [innerHTML]="message.body + message.formattedBody" appCustomLink class="multiline-ellipsis"></span>
        } @else {
          @if (message.formattedBody) {
            <span [innerHTML]="message.formattedBody" appCustomLink class="multiline-ellipsis"></span>
          } @else {
            <span [innerHTML]="message.body" appCustomLink></span>
          }
        }
      </div>
    </div>
  </div>
}
